import { Component, OnInit } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';

@Component({
  selector: 'app-probation-complete-report',
  templateUrl: './probation-complete-report.component.html',
  styleUrls: ['./probation-complete-report.component.css']
})
export class ProbationCompleteReportComponent implements OnInit {

  probationCompleteDetailsReport=[];

  constructor(private masterDataService: MasterDataService) { }

  ngOnInit(): void {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; 
    const currentYear = currentDate.getFullYear();
    
    this.getProbationCompleteDetails(currentMonth, currentYear);
  }

  getProbationCompleteDetails(month: number, year: number) {
    this.masterDataService
        .getProbationCompleteDetails(month,year)
        .subscribe((res:any) => {
          this.probationCompleteDetailsReport = res;
        });
  }

}
